export default __webpack_public_path__ + "static/media/discounted-rifles.aeda2fcb.svg";